import ShareRow from "./ShareRow";
import CommentsThread from "./CommentsThread";

// Render a chapter body, splitting on \n\n and styling the THE COST / A PICTURE OF IT / THE PRACTICE labels.
const SECTION_LABELS = new Set(["THE COST", "A PICTURE OF IT", "THE PRACTICE"]);

function renderBody(text) {
  const blocks = text.split(/\n\n+/);
  return blocks.map((b, i) => {
    const trimmed = b.trim();
    const key = `block-${i}-${trimmed.slice(0, 16)}`;
    if (SECTION_LABELS.has(trimmed)) {
      return (
        <p key={key} className="font-ui text-[11px] uppercase tracking-[0.3em] text-primary mt-10 mb-3">
          {trimmed}
        </p>
      );
    }
    if (trimmed.startsWith("Roots of the wisdom")) {
      return (
        <p key={key} className="font-body italic text-foreground/80 leading-relaxed mt-10 pt-6 border-t border-border">
          {trimmed}
        </p>
      );
    }
    if (trimmed.startsWith("A question to sit with")) {
      return (
        <blockquote key={key} className="mt-8 border-l-4 border-primary pl-6 py-2 font-display text-2xl italic text-secondary leading-snug">
          {trimmed.replace("A question to sit with.", "").replace("A question to sit with:", "").trim() || trimmed}
        </blockquote>
      );
    }
    return (
      <p key={key} className={`font-body text-lg md:text-xl leading-relaxed mb-6 text-foreground/95 ${i === 0 ? "drop-cap" : ""}`}>
        {trimmed}
      </p>
    );
  });
}

export default function ChapterArticle({ chapter, prefix, anchorId, hideComments = false, pullQuote, image, imageAlt }) {
  const baseUrl = typeof window !== "undefined" ? window.location.origin + window.location.pathname + "#" + anchorId : "";

  return (
    <article id={anchorId} data-testid={`chapter-${anchorId}`} className="scroll-mt-24 mb-24">
      {image && (
        <figure className="mb-10 overflow-hidden rounded-2xl border border-border">
          <img
            src={image}
            alt={imageAlt || chapter.title}
            className="w-full h-64 md:h-80 object-cover"
            loading="lazy"
          />
        </figure>
      )}
      <header className="mb-8">
        <p className="font-ui text-[11px] uppercase tracking-[0.35em] text-primary mb-3">{prefix}</p>
        <h2 data-testid="chapter-title" className="font-display text-4xl md:text-5xl text-foreground leading-[1.05] tracking-tight">
          {chapter.title}
        </h2>
        {pullQuote && (
          <p className="mt-6 font-display italic text-2xl md:text-3xl text-secondary leading-snug max-w-2xl">
            “{pullQuote}”
          </p>
        )}
        <div className="wobble-divider mt-6" />
      </header>
      <div data-testid="chapter-body" className="max-w-prose">
        {renderBody(chapter.body)}
      </div>
      <div className="mt-12 max-w-prose">
        <ShareRow title={chapter.title} chapterUrl={baseUrl} testIdPrefix={`share-${anchorId}`} />
      </div>
      {!hideComments && (
        <div className="max-w-prose">
          <CommentsThread chapterId={anchorId} />
        </div>
      )}
    </article>
  );
}
